import React, { PureComponent } from 'react';
import { actions as termActions } from '../../reducers/terms';
import { selectors as configSelectors } from '../../reducers/configurations';
import { TextField } from '@cimpress/react-components';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import { history } from '../../utils/history';
import { css, cx } from 'emotion';
import { withTranslation } from 'react-i18next';
import TermStatus from '../../constants/termStatus';
const buttonStyle = css({
  height: '48px',
  padding: '9px 12px !important'
});

const helpTextStyle = css({
  '.help-block': {
    marginBottom: '0px'
  }
});

class InvestigateSku extends PureComponent {
  state = {
    sku: '',
    error: ''
  };

  onInputChange = e => {
    this.setState({ sku: e.target.value.toUpperCase(), error: '' });
  };

  onSearch = e => {
    const { sku } = this.state;
    const { fetchTermsBySku, t, showTerminated } = this.props;
    e.preventDefault();
    if (!sku) {
      this.setState({ error: t('investigateSku:emptySearch') });
      return;
    }

    return fetchTermsBySku(sku)
      .then(terms => {
        if (isEmpty(terms) || (!showTerminated && terms.every(t => t.status === TermStatus.TERMINATED))) {
          this.setState({ error: t('investigateSku:noContractsFound', { sku }) });
          return;
        }

        history.push(`/skus/${sku}`);
      })
      .catch(error => {
        this.setState({
          error: isString(error)
            ? error
            : t('errors:withCommentAndStatusCode', {
                serviceComment: error.serviceComment,
                statusCode: error.statusCode
              })
        });
      });
  };

  render() {
    const { t } = this.props;
    return (
      <form onSubmit={this.onSearch}>
        <div style={{ display: 'flex' }}>
          <TextField
            name="btnMid"
            style={{ minWidth: '0px', marginBottom: '0px' }}
            className={helpTextStyle}
            placeholder="CIM-ABC123"
            value={this.state.sku}
            onChange={this.onInputChange}
            bsStyle={this.state.error ? 'error' : ''}
            helpText={
              <span
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  display: 'block'
                }}>
                {this.state.error || ''}
              </span>
            }
          />
          <button onClick={this.onSearch} className={cx('btn btn-default', buttonStyle)}>
            {t('investigateSku:getDetails')}
          </button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  showTerminated: configSelectors.getShowTerminated(state)
});

const mapDispatchToProps = {
  fetchTermsBySku: termActions.fetchTermsBySku
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(InvestigateSku));
